import toast from "react-hot-toast";
import { applyQueryParams } from "../utils/request";
import instance from "./api";
import { execute } from "./response";

const getCompetitions = async (params) => {
  const endpoint = `${process.env.REACT_APP_API_URL}/api/competitions`;
  return execute(() => instance.get(applyQueryParams(endpoint, params)));
};

const postCompetition = async (data) => {
  const endpoint = `${process.env.REACT_APP_API_URL}/api/competitions`;
  return execute(() => instance.post(applyQueryParams(endpoint), data));
};

const putCompetition = async (id, data) => {
  const endpoint = `${process.env.REACT_APP_API_URL}/api/competitions/${id}`;
  return execute(() => instance.put(applyQueryParams(endpoint), data));
};

const approveCompetition = async (id) => {
  const endpoint = `${process.env.REACT_APP_API_URL}/api/competitions/${id}/approve`;
  return execute(() => instance.post(endpoint));
};

const unapproveCompetition = async (id) => {
  const endpoint = `${process.env.REACT_APP_API_URL}/api/competitions/${id}/unapprove`;
  return execute(() => instance.post(endpoint));
};

const deleteCompetition = async (id) => {
  const endpoint = `${process.env.REACT_APP_API_URL}/api/competitions/${id}`;
  return execute(() => instance.delete(applyQueryParams(endpoint)));
};

const mergeCompetitions = async (sport, data) => {
  const endpoint = `${process.env.REACT_APP_API_URL}/api/competitions/${sport}/merge`;
  return execute(() => instance.post(applyQueryParams(endpoint), data));
};

const matchCompetitionsByAi = async (sport, payload) => {
  try {
    const endpoint = `${process.env.REACT_APP_API_URL}/api/competitions/${sport}/ai/match`;
    const result = await execute(() => instance.post(endpoint, payload, { timeout: 600000 }));
    return result;
  } catch (e) {
    console.log(e);
    toast.error('Servers are busy. Try again later!');
  }
};

const getAllCompetitionsByLeague = async (params) => {
  const endpoint = `${process.env.REACT_APP_API_URL}/api/competitions`;
  const res = await instance.get(
    applyQueryParams(endpoint, [...params, {
      key: 'take',
      value: 10_000
    }, {
      key: 'skip',
      value: 0
    }])
  );
  return res.data?.data;
};

export {
  getAllCompetitionsByLeague,
  getCompetitions,
  postCompetition,
  putCompetition,
  deleteCompetition,
  mergeCompetitions,
  matchCompetitionsByAi,
  approveCompetition,
  unapproveCompetition
};
